import { IItemsCategory } from 'types/entities';
import { EntityService } from '../entity.service';


class CategoriesService extends EntityService<IItemsCategory> {
  readonly entityName = 'item_category';
}

export default new CategoriesService();
